<template>
  <div :key="networkType.id">
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'networkType',
        ]),
    },
    async beforeRouteUpdate(to, from, next) {
        if (from.params.networkTypeId !== to.params.networkTypeId) {
            if (await this.getNetworkTypeInfo(to.params.networkTypeId)) {
                next();
            }
        } else {
            next();
        }
    },
    methods: {
        ...mapActions({
            getNetworkTypeInfo: 'getNetworkTypeInfo',
        }),
    },
};
</script>
